import { Component, forwardRef, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { catchError, EMPTY, finalize } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

import { ClientsService } from '../../../services/clients.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientFormComponent } from '../../../shared/common-forms/client-form/client-form.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-client-create-form',
    templateUrl: './create.component.html',
    styleUrl: './create.component.scss',
    imports: [
      forwardRef(() => ClientFormComponent),
      MatButtonModule,
      MatIconModule,
      MatToolbarModule,
    ]
})
export class ClientCreateFormComponent {
  private readonly fb = inject(FormBuilder);

  private readonly clientService = inject(ClientsService);

  private readonly snackBar = inject(MatSnackBar);


  public creating = signal(false);

  public form: FormGroup = this.fb.group({
    id: null,
    rut: this.fb.control(null, [Validators.required]),
    name: '',
    address: '',
    city: '',
    email: '',
    phone: '',
    correlative_id: null,
    rating: this.fb.control(0, { nonNullable: true, validators: [Validators.min(0), Validators.max(5)] }),
    custom_fields: this.fb.group({}),
  });

  private readonly matDialogRef = inject(MatDialogRef<ClientCreateFormComponent>);

  createClient() {
    this.creating.set(true);
    this.clientService.create(this.form.value).pipe(
      catchError(() => {
        this.snackBar.open('Error al crear el cliente', 'error');
        return EMPTY;
      }),
      finalize(() => this.creating.set(false)),
    ).subscribe((client) => {
      this.matDialogRef.close(client);
    });
  }
}
